<template>
  <v-dialog v-model="show" max-width="500px" @keydown.enter="addItem">
    <!--<v-btn slot="activator" color="#000000" dark class="add-button mb-2">Lisää tuote</v-btn>-->
    <v-card>
      <v-card-title class="pl-3">
        <span class="headline">Lisää henkilö</span>
      </v-card-title>
      <v-container grid-list-md class="pt-0 pb-0 add-product-container">
        <v-row wrap>
          <v-col cols="6">
            <v-text-field v-model="newItem.id" label="Avecor id* (Tomi lisää)" autofocus required></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="newItem.firstName" label="Etunimi*" required></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="newItem.lastName" label="Sukunimi*" required></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="newItem.email" label="Email*" required></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              v-model="newItem.role"
              :items="settings.roles"
              persistent-hint
              item-text="text"
              item-value="value"
              label="Valitse rooli*"
            />
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="avecor-button-global add-button mb-2" text @click="close">Peruuta</v-btn>
        <v-btn class="avecor-button-global add-button mb-2" text @click="addItem" >Lisää</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'

export default {
    props:['visible'],
    data: () => ({
      autogrow:true,
      editedIndex: -1,
       newItem: {
        id: '',
        email: '',
        firstName: '',
        lastName: '',
        role: '',
        marginRateGoals:{
            "2020":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2021":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2022":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2023":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2024":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2025":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            }

          },
          goals:{
            "2020":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2021":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2022":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2023":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2024":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2025":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            }
          },
          marginGoals:{
            "2024":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2025":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            }
          },
      },
      defaultItem: {
        id: '',
        email: '',
        firstName: '',
        lastName: '',
        role: '',
        marginRateGoals:{
            "2020":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2021":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2022":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2023":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2024":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2025":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            }

          },
          goals:{
            "2020":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2021":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2022":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2023":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2024":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2025":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            }
          },
          marginGoals:{
            "2024":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            },
            "2025":{
              "1":0,
              "2":0,
              "3":0,
              "4":0,
              "5":0,
              "6":0,
              "7":0,
              "8":0,
              "9":0,
              "10":0,
              "11":0,
              "12":0,
            }
          },
      },   
    }),
    mounted() {
    },
    computed: {
      show: {
        get () {
          return this.visible
        },
        set (value) {
          if (!value) {
            this.$emit('close')
          }
        }
      },
      ...mapFields([
        'staff.staff',
        'settings',
        'user',
      ]),
    },
    created () {},
    methods: {
      customFormatter(date) {
        var da = dateFormat(date, "yyyy-mm-dd")
        return da
      },
      close () {
        this.show = false
        setTimeout(() => {
          this.newItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      async addItem () {
        if(this.newItem.firstName === '') {
          alert('Etunimi puuttuu')
          return
        }
        let {id, ...y} = this.newItem;
        var data = null
        var weekReports = {}
        for (var i = 2022; i <= 2030; i++){
            weekReports[i] = {}
            for (var j = 1; j <= 53; j++){
              data = this.getDataForWeek(j,i)
              var period = data.startDay+'.'+data.startMonth+'-'+data.endDay+'.'+data.endMonth
              //console.log(data)
              //if(j== 53){console.log(data)}
              if(j == 53){
                if(data.thursdayMonth == 12){ 
                  weekReports[i][data.wednesdayMonth] === undefined ? weekReports[i][data.wednesdayMonth]={} : ''
                  weekReports[i][data.wednesdayMonth][j]={agreedVisits:0,comments:'',period,startDay:data.startDay,startMonth:data.startMonth,endDay:data.endDay,endMonth:data.endMonth}  
                }
              }
              else {
                weekReports[i][data.wednesdayMonth] === undefined ? weekReports[i][data.wednesdayMonth]={} : ''
                weekReports[i][data.wednesdayMonth][j]={agreedVisits:0,comments:'',period,startDay:data.startDay,startMonth:data.startMonth,endDay:data.endDay,endMonth:data.endMonth}  
              }
            }
        }
        const newId = await this.$store.dispatch('staff/set', {
          id,
          ...y,
          weekReports
        })
        this.close()
      },
      getDataForWeek(weekNo,year){
        var d = new Date(year, 0, 1);
        var firstWeek = this.getFirstOfTheYearWeekNumber(year)
        if(firstWeek != 1){
          d = new Date(d.setDate(d.getDate() + 7))
        }
        var daysSinceMonday = d.getDay()-1
        //console.log(daysSinceMonday)
        if(daysSinceMonday < 0) daysSinceMonday = 6
        d.setDate(d.getDate() - daysSinceMonday);
        d.setDate(d.getDate() + ( 7 * (weekNo-1)));
        
        var startDay = d.getDate() 
        var startMonth = d.getMonth()+1
        var year = d.getFullYear()

        var wednesday = new Date(d.setDate(d.getDate() + 2))
        var thursday = new Date(d.setDate(d.getDate() + 1))
        var friday = new Date(d.setDate(d.getDate() + 1))
        var wednesdayMonth = wednesday.getMonth()+1
        var thursdayMonth = thursday.getMonth()+1
        var endDay = friday.getDate() 
        var endMonth = friday.getMonth()+1
        return {thursdayMonth,startDay,startMonth,endDay,endMonth,wednesdayMonth}
      },
      getFirstOfTheYearWeekNumber(year) {
        var date = new Date(year, 0, 1);
        //var date = new Date(this.getTime());
        date.setHours(0, 0, 0, 0);
        // Thursday in current week decides the year.
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        // January 4 is always in week 1.
        var week1 = new Date(date.getFullYear(), 0, 4);
        // Adjust to Thursday in week 1 and count number of weeks from date to week1.
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
                              - 3 + (week1.getDay() + 6) % 7) / 7);
      },
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/AddStaff.vue